import { ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';

interface IconProps extends ComponentPropsWithoutRef<'svg'> {
  link: string;
  name: string;
}

export default function Icon({link, name, className, ...rest}: IconProps) {
  return (
    <svg className={classNames('max-h-full max-w-full', className)} {...rest}>
      <use xlinkHref={`${link}#${name}`} />
    </svg>
  )
}
